import { useState } from "react"
import "./AmountInput.scss"

interface Props {
    value: number
    onChange: (value: number) => void
    onBlur?: () => void
    disabled?: boolean
}
const AmountInput = (props: Props) => {
    const {value, onChange = () => {}, disabled = false, onBlur} = props
    const formatter = new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 2})
    const [valueString, setValueString] = useState(formatter.format(value / 100))

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const stringValue = e.target.value
        setValueString(stringValue)
        const computedValue = Math.round(parseFloat(stringValue.replace(',', '.')) * 100) || 0
        if(computedValue !== value) {
            onChange(computedValue)
        }
    }
    
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if(!!onBlur) {
            onBlur()
        }
    }
    
    return <div className="amount-input">
        <input
            placeholder="0"
            value={valueString}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={disabled}/>
        <div className="unit">€</div>
    </div>
}

export default AmountInput